import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

export function getFormAgreement() {
  return requestApi<{
    formUseAgreed: boolean;
  }>({
    url: withForm('/terms'),
    method: 'GET',
    credentials: true,
  }).then((res) => res.data);
}

export function updateFormAgreement(data: { formUseAgreed: boolean }) {
  return requestApi<{
    formUseAgreed: boolean;
  }>({
    method: 'PUT',
    url: withForm('/terms'),
    data,
    credentials: true,
  }).then((res) => res.data);
}
